<i18n>
{
	"en": {
		"natureOfCargoCodeList" : "Goodstypes",
		"partyCodeList" : "Party",
		"chargeCodeList" : "Charges",
		"serviceCodeList" : "Services",
		"freeTextCodeList" : "Freetexts",
		"conditionCodeList" : "Event codes",
		"referenceCodeList" : "References",
		"palletTypeCodeList" : "Pallets",
		"packageTypeCodeList" : "Package types",
		"tariffReferenceCodeList" : "Tariff Reference",
		"todCodelist" : "Terms of delivery"
	},
	"no":{
		"natureOfCargoCodeList" : "Godstyper",
		"partyCodeList" : "Addresser",
		"chargeCodeList" : "Priskoder",
		"serviceCodeList" : "Servicer",
		"freeTextCodeList" : "Fritekster",
		"conditionCodeList" : "Hendelseskoder",
		"referenceCodeList" : "Referansekoder",
		"palletTypeCodeList" : "Pallekoder",
		"packageTypeCodeList" : "Kolli koder",
		"tariffReferenceCodeList" : "Tariff referanser",
		"todCodelist" : "Leveringsbetingelser"
	}
}
</i18n>
<template>
	<t-tab-view
		style="padding:0.3em"
		sidebar
	
		:tabs="tabs"
	/>

</template>

<script>

import ManageCodelist from './ManageCodelist.vue';

export default {
	name: 'ManageCodelists',
	props: {
		edisetup: Object
	},

	data() {
		return {
			tabs: this.createTabs(),
		};
	},
	methods: {
		createTabs() {
			if (!this.edisetup.codeList)
				return [];
			return Object.keys(this.edisetup.codeList).filter(x => x.toLowerCase().indexOf('codelist') > -1)
				.sort(this.sorting).map(x =>  ({
				  label: `${this.$t(x)}(${this.edisetup.codeList[x].length})`, component: ManageCodelist, value: { name: this.$t(x), codelist: this.edisetup.codeList[x], id: this.edisetup.codeList.r10Id, edisetup: this.edisetup }
				}));
			
		},
		sorting(a, b) {
			let codelistA = this.edisetup.codeList[a];
			let codeListB = this.edisetup.codeList[b];
			return codeListB.length - codelistA.length;
		}
	}
};
</script>

<style>

</style>